/**
 * Copy and response handling for retrying failed integration actions. A retry does not post to the DMS
 * inline: the API publishes the payment to a broker and returns immediately, so there is no response
 * to wait on. The DMS service resolves the row later, once the post actually lands. Everything here
 * exists to keep the wording honest about that -- the API reports `queued`, and the row stays in the
 * report until the DMS confirms it.
 */

export const RETRY_QUEUED_TOAST =
  'Repost queued. It sends to your DMS in the background — refresh in a minute to see the result.'

/** Retry All's line after the queued count. */
export const RETRY_ALL_BACKGROUND =
  'They send to your DMS in the background — refresh in a few minutes to see results.'

export const RETRY_ALL_QUEUED_TOAST = `Reposts queued. ${RETRY_ALL_BACKGROUND}`

export const RETRY_QUEUE_FAILED_TOAST =
  'Unable to queue the repost right now. Try again later.'

export const RETRY_BUTTON_LABEL = 'Queue Retry'

export const RETRY_TOOLTIP =
  'Queue this payment to be reposted to your DMS. The repost runs in the background.'

interface RetryResponse {
  status?: string
}

interface FailedActionRetryState {
  retries?: number
  last_retry?: string | null
  retried_by_name?: string | null
}

/** True when the API accepted the repost and handed it to the broker. */
export function isRetryQueued(data?: RetryResponse | null): boolean {
  return data?.status === 'queued'
}

/** Short line for a row with a repost already in flight. Empty when none is. */
export function retryQueuedLine(action: FailedActionRetryState): string {
  const retries = action?.retries || 0
  if (!retries) return ''

  const who = action.retried_by_name || 'a user'
  const attempts = retries > 1 ? ` (${retries} attempts)` : ''

  return `Queued by ${who}${attempts}`
}
